import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";
import endpoints from "../../api/endpoints";


export interface Site {
  Code: string;
  Libelle: string;
}

interface SitesState {
  sites: Site[] | null;
  loading: boolean;
  error: string | null;
}

const initialState: SitesState = { sites: null, loading: false, error: null };

export const fetchSites = createAsyncThunk(
  "sites/getAll",
  async () => {

    const response = await axiosInstance.get(endpoints.sites.allSites);
    return response.data;
  }
);

const sitesSlice = createSlice({
  name: "sites",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSites.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSites.fulfilled, (state, action) => {
        state.loading = false;
        state.sites = action.payload;
      })
      .addCase(fetchSites.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch sites!";
      });
  },
});

export default sitesSlice.reducer;
